import PropTypes from "prop-types";
import { Background } from "@/components/utils/Background";
import { Button } from "@/components/utils/Button";
import "./styles.scss";

/* #META
 {
  "NAME": "Title Text",
  "CLASSNAME": "title-text-component",
  "URL": "http://nicasource.local"
 }
#ENDMETA */

const TitleText = ({ data }) => {
  const { content_banner } = data || {};
  if (!content_banner) return null;

  const {
    background_component: backgroundComponent,
    show_banner_title: showBannerTitle,
    banner_title: bannerTitle,
    button_component: bannerButton,
    title_position: titlePosition,
    title_color: titleColor,
    text_content: textContent,
    show_secondary_button: showSecondaryButton,
    secondary_button_component: secondButtonComponent,
    buttons_alignment: buttonsAlignment,
  } = content_banner;

  const alignSelfMap = (pos) => {
    switch ((pos || "").toString()) {
      case "center":
        return "center";
      case "end":
        return "end";
      case "start":
        return "start";
      default:
        return "start";
    }
  };

  const titleAlign = alignSelfMap(titlePosition);

  return (
    <section className="title-text-component">
      <Background asBackground {...backgroundComponent} />

      {!backgroundComponent.background_type ? "" : <div className="overlay"></div>}
      <div className="container-revamp inner-banner-container">
        {showBannerTitle && bannerTitle && (
          <span
            className={`banner-title banner-title--${titleColor}`}
            style={{ textAlign: titleAlign }}
          >
            {bannerTitle}
          </span>
        )}
        {textContent && (
          <div className="banner-content" dangerouslySetInnerHTML={{ __html: textContent }} />
        )}
        {bannerButton && !showSecondaryButton ? (
          <Button {...bannerButton} />
        ) : (
          secondButtonComponent && (
            <div className="button-container" style={{ justifyContent: buttonsAlignment }}>
              <Button {...bannerButton} />
              {showSecondaryButton && <Button {...secondButtonComponent} />}
            </div>
          )
        )}
      </div>
    </section>
  );
};

TitleText.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      acf_fc_layout: PropTypes.string,
      content_banner: PropTypes.shape({
        text_content: PropTypes.string,
        show_banner_title: PropTypes.bool,
        banner_title: PropTypes.string,
        button_component: PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
          target: PropTypes.string,
        }),
        show_secondary_button: PropTypes.bool,
        secondary_button_component: PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
          target: PropTypes.string,
        }),
        buttons_alignment: PropTypes.oneOf(["flex-start", "center", "flex-end"]),
        background_component: PropTypes.shape({
          background_3d_model: PropTypes.string,
          background_3d_model_file: PropTypes.string,
          background_color: PropTypes.string,
          background_embed: PropTypes.string,
          background_image_position: PropTypes.string,
          background_image: PropTypes.shape({
            url: PropTypes.string,
            alt: PropTypes.string,
            title: PropTypes.string,
          }),
          background_type: PropTypes.string,
          background_video: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default TitleText;
